import { useState } from 'react'

const useClipboard = () => {
  const [copied, setCopied] = useState(false)

  const onSuccessCopy = () => {
    if (!copied) {
      setCopied(true)
    }
    setTimeout(() => setCopied(false), 2000)
  }

  const fallbackCopyTextToClipboard = (value: string) => {
    const dummy = document.createElement('input')
    document.body.appendChild(dummy)
    dummy.value = value

    // Avoid scrolling to top
    dummy.style.top = '0'
    dummy.style.left = '0'
    dummy.style.position = 'fixed'
    dummy.focus()
    dummy.select()

    document.execCommand('copy')
    onSuccessCopy()

    document.body.removeChild(dummy)
  }

  const onCopy = (value: string) => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(value)
    } else {
      navigator.clipboard.writeText(value).then(() => onSuccessCopy())
    }
  }

  return {
    copied,
    onCopy,
  }
}

export default useClipboard
